import { format } from 'owa-localize';
import { makePatchRequest } from 'owa-ows-gateway';
import { ConnectedAccountResponse } from '../contracts/ConnectedAccountResponse';
import { ErrorResponse, ErrorType } from '../contracts/ErrorResponse';
import { isSuccessStatusCode, HttpStatusCode } from 'owa-http-status-codes';

const refreshConnectedAccountAccessTokenUrl: string = 'ows/beta/ConnectedAccounts/refreshtoken/{0}';

export async function refreshConnectedAccountAccessToken(
    id: string
): Promise<ConnectedAccountResponse | ErrorResponse> {
    const response = await makePatchRequest(
        format(refreshConnectedAccountAccessTokenUrl, id),
        null,
        undefined /* correlation id */,
        true /* returnFullRepsonse */
    );

    if (
        isSuccessStatusCode(response.status) ||
        response.status == HttpStatusCode.BadRequest ||
        response.status == HttpStatusCode.NotFound
    ) {
        return response.json();
    }

    return { error: ErrorType.Transient.toString() } as ErrorResponse;
}
